import { ComponentType, useContext } from "react";
import { FullScreenPermissionsError } from "../Common/InsufficientPermissions";
import { AuthContext } from "./AuthContext";
import { AuthContextType } from "./types";

export type PermissionOptions = Parameters<AuthContextType["authorized"]>[0];

export const withAuthorization = <P extends {}>(
  WrappedComponent: ComponentType<P>,
  permissionOptions: PermissionOptions,
) => {
  return (props: P) => {
    const { authorized } = useContext(AuthContext);

    return authorized(permissionOptions) ?
        <WrappedComponent {...props} />
      : <FullScreenPermissionsError />;
  };
};
